export default {
  ServerURL: process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : 'https://api.revision.link/',
  WebURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://alpha.revision.link'
};
